import { useTranslation } from 'react-i18next';
export const useDamageTypes = () => {
    const { t } = useTranslation();
    return [
        { value: 'bludgeoning', label: t('damageTypes.bludgeoning') },
        { value: 'piercing', label: t('damageTypes.piercing') },
        { value: 'slashing', label: t('damageTypes.slashing') },
        { value: 'poison', label: t('damageTypes.poison') },
        { value: 'fire', label: t('damageTypes.fire') },
        { value: 'cold', label: t('damageTypes.cold') },
        { value: 'lightning', label: t('damageTypes.lightning') },
        { value: 'thunder', label: t('damageTypes.thunder') },
        { value: 'acid', label: t('damageTypes.acid') },
        { value: 'psychic', label: t('damageTypes.psychic') },
        { value: 'force', label: t('damageTypes.force') },
        { value: 'necrotic', label: t('damageTypes.necrotic') },
        { value: 'radiant', label: t('damageTypes.radiant') },
        { value: 'all', label: t('damageTypes.all') },
    ];
};
